import { gql } from '@apollo/client';
import {
  archivePostsFragment,
  archiveEventsFragment,
  archiveVideosFragment,
  archiveAudioFragment,
  archivePodcastsFragment,
  archiveConversationsFragment,
  archivePartnersFragment,
} from '@/lib/wp/archives/queryArchives';

// contentTypes: [POST, HDM_AUDIO, HDM_EVENTS, HDM_PODCASTS, HDM_VIDEOS, HDM_PARTNERS, HDM_CONVERSATIONS]
const querySearch = gql`
  query GET_POSTS_BY_TAG(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $orderBy: PostObjectsConnectionOrderbyEnum = DATE
    $order: OrderEnum = DESC
    $imageSize: MediaItemSizeEnum = LARGE
    $query: String!
  ) {
    contentNodes(
      first: $first
      last: $last
      after: $after
      before: $before
      where: {
        contentTypes: [POST, HDM_AUDIO, HDM_EVENTS, HDM_PODCASTS, HDM_VIDEOS, HDM_PARTNERS, HDM_CONVERSATIONS]
        search: $query
        orderby: { field: $orderBy, order: $order }
        dateQuery: { after: { day: 1, month: 1, year: 2016 } }
      }
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          ...ArchivePostFields
          ...ArchiveEventFields
          ...ArchiveVideoFields
          ...ArchiveAudioFields
          ...ArchivePodcastFields
          ...ArchivePartnerFields
          ...ArchiveConversationFields
        }
      }
    }
  }
  ${archivePostsFragment}
  ${archiveEventsFragment}
  ${archiveVideosFragment}
  ${archiveAudioFragment}
  ${archivePodcastsFragment}
  ${archivePartnersFragment}
  ${archiveConversationsFragment}
`;

export default querySearch;
